import { render, staticRenderFns } from "./swiperForm.vue?vue&type=template&id=10cb50f8&scoped=true&"
import script from "./swiperForm.vue?vue&type=script&lang=js&"
export * from "./swiperForm.vue?vue&type=script&lang=js&"
import style0 from "./swiperForm.vue?vue&type=style&index=0&id=10cb50f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cb50f8",
  null
  
)

export default component.exports